import { z } from "zod";

export const ToolInstanceIdSchema = z
  .string()
  .regex(/^tool_[a-f0-9]{8}$/u, "Expected a tool instance ID");

export const ToolUrlIdSchema = z.string().regex(/^[a-f0-9]{8}$/u, "Expected a tool URL ID");

export const LegacyAppInstanceIdSchema = z
  .string()
  .regex(/^app_i_[a-f0-9]{8}$/u, "Expected a legacy app instance ID");

export function currentToolInstanceId(value: string): string {
  const current = ToolInstanceIdSchema.safeParse(value);
  if (current.success) return current.data;

  const suffix = LegacyAppInstanceIdSchema.parse(value).slice("app_i_".length);
  return ToolInstanceIdSchema.parse(`tool_${suffix}`);
}

export function toolUrlIdFromInstanceId(value: string): string {
  return ToolUrlIdSchema.parse(ToolInstanceIdSchema.parse(value).slice("tool_".length));
}

export function toolInstanceIdFromUrlId(value: string): string {
  return ToolInstanceIdSchema.parse(`tool_${ToolUrlIdSchema.parse(value)}`);
}

export function toolUrlIdFromLegacyReference(value: string): string {
  return toolUrlIdFromInstanceId(currentToolInstanceId(value));
}
